import { alpha, Box, CircularProgress, Typography, useTheme } from '@mui/material'
import { amber, blue, green, grey, purple, red, lightBlue, yellow } from '@mui/material/colors';
import { getContrastColor } from '../../utils/Color';
import { memo } from 'react';
import { COLORS } from '../../styles/theme';


const colors = {
    manual: lightBlue,
    automation: purple,

    paid: green,
    passed: green,
    pass: green,
    failed: red,
    fail: red,

    skipped: yellow,
    skip: yellow,
    blocked: grey,
    not_executed: grey,

    pending: yellow,
    inprogress: blue,
    expired: red,

    active: green,
    inactive: grey,
    expiredsoon: amber,


    verified: green,
    unverified: red,
    invited: yellow,

    // activity actions
    delete: red,
    create: green,
    update: blue,


    // task status
    open: blue,
    close: red,


    // paymentTerms status
    prepaid: green,
    postpaid: red,

    // invoices status
    finalized: green,
    inprocess: blue,
    draft : amber,


    // report publish status
    published : blue,
    unpublished : grey,
};


function getLocalColor(status) {

    return colors[status?.trim()?.toLowerCase()]?.[900] || grey[900];
}

function BadgeComponent({ text, props }) {
    const theme = useTheme();

    if (!Object.keys(colors).includes(text?.toLowerCase())) {
        return (
            <Box className="flex items-center justify-center px-2  w-full overflow-hidden" >
                <Typography className="flex-1 text-center" fontWeight="bold" >{"-"}</Typography>
            </Box>
        )
    };

    return (
        <Box className={`flex items-center justify-center px-2  w-full overflow-hidden ${props?.className}`}{...props} sx={{ bgcolor: alpha(getLocalColor(text), 0.1), ...props?.sx }} borderRadius={theme.shape.borderRadius}>
            <Typography className="flex-1 flex items-center justify-center gap-1 text-center" fontWeight="bold" sx={{ color: getLocalColor(text) }}>{text}</Typography>
        </Box>
    )
}

export default BadgeComponent;